import { render, staticRenderFns } from "./DistribucionVertedero.vue?vue&type=template&id=01537221&"
import script from "./DistribucionVertedero.vue?vue&type=script&lang=js&"
export * from "./DistribucionVertedero.vue?vue&type=script&lang=js&"
import style0 from "./DistribucionVertedero.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports